import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessagesSquare } from "lucide-react";
import { adminApi } from "../../lib/adminApi";
import { Card, PageTitle, Btn, run, fmtDateTime } from "../../components/admin/AdminUI";

const FILTERS = [["all", "All"], ["unread", "New"], ["read", "Handled"]];

export default function Leads() {
  const [filter, setFilter] = useState("all");
  const [data, setData] = useState(null);
  const load = useCallback(() => adminApi.get("/admin/leads", { params: { status: filter } }).then((r) => setData(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);
  const toggle = async (l) => { if (await run(() => adminApi.patch(`/admin/leads/${l.id}`, { read: l.status !== "read" }))) load(); };

  return (
    <div data-testid="admin-leads">
      <PageTitle eyebrow="Chat" title="Chat leads" actions={data && <span className="text-sm text-slate-600" data-testid="leads-unread-count">{data.unread} new</span>} />
      <div className="flex gap-1 mb-5">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} data-testid={`leads-filter-${v}`} className={`h-9 px-4 text-sm border ${filter === v ? "bg-amber-500 border-amber-500 text-slate-900 font-semibold" : "bg-white border-slate-300 text-slate-700 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
      {!data ? <p className="text-slate-500">Loading…</p> : data.items.length === 0 ? <Card><p className="text-sm text-slate-500" data-testid="leads-empty">No callback requests yet.</p></Card> : (
        <div className="space-y-3" data-testid="leads-list">
          {data.items.map((l) => {
            const isNew = l.status !== "read";
            return (
              <article key={l.id} className={`panel p-5 ${isNew ? "border-l-4 !border-l-amber-500" : ""}`} data-testid={`lead-${l.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-slate-900">{l.name}</span>
                      <span className="text-[10px] font-mono uppercase bg-slate-100 text-slate-700 px-1.5 py-0.5">Chat</span>
                      {isNew && <span className="text-[10px] font-mono uppercase bg-amber-100 text-amber-800 px-1.5 py-0.5">New</span>}
                    </div>
                    <div className="mt-1 flex flex-wrap gap-4 text-xs text-slate-600">
                      <a href={`tel:${l.phone}`} className="flex items-center gap-1 hover:text-brand-600"><Phone className="w-3 h-3" />{l.phone}</a>
                      {l.email && <a href={`mailto:${l.email}`} className="flex items-center gap-1 hover:text-brand-600"><Mail className="w-3 h-3" />{l.email}</a>}
                      <span>{fmtDateTime(l.created_at)}</span>
                      <span>Email to team: {l.email_log?.[0]?.status || "—"}</span>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Link to={l.transcript_path} className="btn-ghost h-10 px-3 text-sm" data-testid={`lead-transcript-${l.id}`}><MessagesSquare className="w-4 h-4" />Transcript</Link>
                    <Btn variant="ghost" onClick={() => toggle(l)} data-testid={`lead-toggle-${l.id}`}>{isNew ? "Mark handled" : "Mark new"}</Btn>
                  </div>
                </div>
                {l.question && <p className="mt-3 text-sm text-slate-800 whitespace-pre-wrap">{l.question}</p>}
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
